import React, { useState } from 'react';

import { ValidPasswordHelper } from '../common/auth/ValidPasswordHelper';
import { Panel } from '../common/panel/Panel.component';
import { Button, Colors } from '../legacy/button/Button.component';
import { Input, InputType } from '../legacy/input/Input.component';
import styles from './ResetPassword.module.css';

interface Props {
  onPasswordResetPress: (password: string, verifyPassword: string) => void;
}

export const ResetPasswordComponent: React.FC<Props> = ({
  onPasswordResetPress,
}) => {
  const [password, setPassword] = useState('');
  const [verifyPassword, setVerifyPassword] = useState('');

  return (
    <div className={styles.resetContainer}>
      <Panel className={styles.resetForm} title="Reset Password">
        <p className={styles.resetLabel}>Set New Password</p>
        <div className={styles.resetInput}>
          <div>
            <Input
              type={InputType.PASSWORD}
              label="New Password"
              value={password}
              onChange={setPassword}
            />
            <Input
              type={InputType.PASSWORD}
              label="Confirm New Password"
              value={verifyPassword}
              onChange={setVerifyPassword}
            />
            <ValidPasswordHelper password={password} />
          </div>
          <Button
            color={Colors.COLOR_SCHEME_2}
            className={styles.resetAction}
            disabled={!password || !verifyPassword}
            onClick={() => {
              onPasswordResetPress(password, verifyPassword);
            }}
          >
            Reset Password
          </Button>
        </div>
      </Panel>
    </div>
  );
};
